namespace gotoAndPlay {
    declare const window: any;
    class Footer {
        constructor(target: JQuery) {
            this.init();
        }

        init(): void {
            let currentLanguage = 'et';
            let language = $('.languages__item');
            let el = language.siblings('.is-current').first();
            let linkValue = el.find('a.languages__link').text();
            if (linkValue) {
                if (linkValue == 'rus') {
                    currentLanguage = 'ru';
                }
            }
            let teliaBaseUrl = ((window as any).gotoAndPlay && (window as any).gotoAndPlay.teliaBaseUrl)
                ? (window as any).gotoAndPlay.teliaBaseUrl
                : 'https://www.telia.ee';
            $.ajax({
                url: teliaBaseUrl + '/ssr/megamenu/footer/?fullPage=1&application=digitark' + '&lang=' + currentLanguage,
                dataType: 'html',
                success: function(response) {
                    let parser = new DOMParser();
                    let doc = parser.parseFromString(response, 'text/html');
                    let frame = doc.querySelector('#telia-footer');
                    $('.footer__conteiner').html(frame);
                },
            });
        }
    }

    export let footer;
    $(function() {
        footer = new Footer($('.footer'));

        $(document).on('click', '.footer__title', (event) => {
            event.preventDefault();
            let currentItemParent = $(event.currentTarget).parent();
            if (currentItemParent.hasClass('is-open')) {
                currentItemParent.removeClass('is-open');
            } else {
                $('.footer__col.is-open').removeClass('is-open');
                currentItemParent.addClass('is-open');
            }
        });
        $(document).on('click', '#38717', (event) => {
            event.preventDefault();
            window.Cookiebot.show();
        });
        $(document).on('click', '#38718', (event) => {
            event.preventDefault();
            window.Cookiebot.show();
        });
    });
}
